var _path, _path2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgLocationMap = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.80722 9.6159C8.14971 9.6159 8.48884 9.54844 8.80526 9.41738C9.12168 9.28632 9.40918 9.09421 9.65135 8.85204C9.89353 8.60986 10.0856 8.32236 10.2167 8.00594C10.3478 7.68952 10.4152 7.35039 10.4152 7.0079C10.4152 6.66542 10.3478 6.32628 10.2167 6.00986C10.0856 5.69345 9.89353 5.40594 9.65135 5.16377C9.40918 4.92159 9.12168 4.72949 8.80526 4.59842C8.48884 4.46736 8.14971 4.3999 7.80722 4.3999C7.11553 4.3999 6.45218 4.67467 5.96308 5.16377C5.47399 5.65286 5.19922 6.31622 5.19922 7.0079C5.19922 7.69959 5.47399 8.36294 5.96308 8.85204C6.45218 9.34113 7.11553 9.6159 7.80722 9.6159V9.6159Z",
    stroke: "#255E8E",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.77639 5.47397C3.19513 -0.762725 12.435 -0.755523 13.8465 5.48118C14.6747 9.13966 12.3989 12.2364 10.4041 14.1521C9.70699 14.8244 8.7763 15.2 7.80784 15.2C6.83938 15.2 5.90869 14.8244 5.21162 14.1521C3.22394 12.2364 0.94819 9.13245 1.77639 5.47397V5.47397Z",
    stroke: "#255E8E",
    strokeWidth: 1.5
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLocationMap, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/location-map.56b097cc.svg";
export { ForwardRef as ReactComponent };